import { render, staticRenderFns } from "./PicPx.vue?vue&type=template&id=0ba4ee26&scoped=true"
import script from "./PicPx.vue?vue&type=script&lang=js"
export * from "./PicPx.vue?vue&type=script&lang=js"
import style0 from "./PicPx.vue?vue&type=style&index=0&id=0ba4ee26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4ee26",
  null
  
)

export default component.exports